
import React from 'react';
import { Link } from 'react-router-dom';

const BusinessVulnerability: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Small Business Vulnerability: The Misconception</h2>
      
      <p className="mb-5 text-gray-700 leading-relaxed">
        Many small business owners operate under the dangerous assumption that their organization's size makes them unattractive 
        to cybercriminals. In reality, the opposite is true:
      </p>
      
      <ul className="space-y-4 mb-6">
        <li className="bg-gray-50 p-4 rounded-md flex items-start">
          <span className="bg-itmgmt-medium-blue text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">1</span>
          <div>
            <span className="font-semibold text-itmgmt-dark-blue">Resource Constraints</span>
            <p className="text-gray-700 mt-1">Small businesses typically operate without dedicated security teams or advanced security infrastructure, making them easier targets.</p>
          </div>
        </li>
        <li className="bg-gray-50 p-4 rounded-md flex items-start">
          <span className="bg-itmgmt-medium-blue text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">2</span>
          <div>
            <span className="font-semibold text-itmgmt-dark-blue">Data Value</span>
            <p className="text-gray-700 mt-1">Even the smallest operations process customer information, financial records, and intellectual property that carries significant value on illicit markets.</p>
          </div>
        </li>
        <li className="bg-gray-50 p-4 rounded-md flex items-start">
          <span className="bg-itmgmt-medium-blue text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">3</span>
          <div>
            <span className="font-semibold text-itmgmt-dark-blue">Supply Chain Vulnerability</span>
            <p className="text-gray-700 mt-1">Small businesses that serve larger organizations can become entry points for attacks targeting those larger entities.</p>
          </div>
        </li>
        <li className="bg-gray-50 p-4 rounded-md flex items-start">
          <span className="bg-itmgmt-medium-blue text-white rounded-full w-6 h-6 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">4</span>
          <div>
            <span className="font-semibold text-itmgmt-dark-blue">Ransomware Economics</span>
            <p className="text-gray-700 mt-1">Attackers understand that small businesses often cannot withstand extended downtime, making them more likely to pay ransoms to quickly restore operations.</p>
          </div>
        </li>
      </ul>
      
      <div className="my-8 p-5 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="font-medium text-itmgmt-dark-blue mb-2">Did you know?</p>
        <p className="text-gray-700">
          According to the 2024 Verizon Data Breach Investigations Report, 43% of all data breaches target small businesses, 
          yet only 14% have adequate defense preparations. Our <Link to="/blog/cybersecurity-best-practices-small-business" className="text-itmgmt-medium-blue underline">cybersecurity best practices guide</Link> can 
          help you bridge this security gap.
        </p>
      </div>
    </>
  );
};

export default BusinessVulnerability;
